import { useFormContext } from "react-hook-form";
import useEvent from "react-use-event-hook";
import { useRecoilState, useSetRecoilState } from "recoil";

import {
  apiDataFetchingErrorsAtom,
  archiveRelationErrorAtomFamily,
  dynamicFormTabIndexAF,
  editFormDataAF,
  editFormDataInitialSnapshotAF,
  EditFormMode,
  errorsCrudContentAtomFamily,
  IExtendableDto,
  RequestBodyModel,
  RydeUiUnit,
} from "@ryde/shared";

export const useCrudFormCleanup = (
  entity: RydeUiUnit,
  mode: EditFormMode = EditFormMode.CrudRoute,
) => {
  const setDto = useSetRecoilState(editFormDataAF([entity, mode]));
  const setInitialSnapshotDto = useSetRecoilState(
    editFormDataInitialSnapshotAF([entity, mode]),
  );
  const formContext = useFormContext<IExtendableDto>();
  const setCrudServerErrors = useSetRecoilState(
    errorsCrudContentAtomFamily(entity),
  );
  const setArchiveRelationError = useSetRecoilState(
    archiveRelationErrorAtomFamily(entity),
  );
  const setApiServerErrors = useSetRecoilState(apiDataFetchingErrorsAtom);
  const [tabIndex, setTabIndex] = useRecoilState(dynamicFormTabIndexAF(entity));

  const resetEditFormPreviousData = useEvent(
    ({
      initialData,
      skipGlobalDto,
      skipFormReset,
    }: {
      initialData?: RequestBodyModel;
      skipGlobalDto?: boolean;
      skipFormReset?: boolean;
    } = {}) => {
      setCrudServerErrors(undefined);
      setArchiveRelationError(false);
      setApiServerErrors(undefined);

      /* reset edit tab index */
      if (tabIndex > 0) {
        setTabIndex(0);
      }

      /* cleanup edit dto from previous edit if not cleared */
      if (initialData) {
        setDto(initialData);
        setInitialSnapshotDto(initialData);
      } else if (!skipGlobalDto) {
        setDto(undefined);
        setInitialSnapshotDto(undefined);
      }

      if (!skipFormReset && formContext?.reset) {
        if (initialData) {
          formContext.reset(initialData);
        } else {
          formContext.reset(undefined);
        }
      }
    },
  );
  return { resetEditFormPreviousData };
};
